import { createSlice } from '@reduxjs/toolkit';
import { storeResources } from '../resources';
import { IInvoicesInitialValues } from './types';
import { ThunkGetInvoices } from './thunks';

const initialState: IInvoicesInitialValues = {
  invoices: [],
};

const invoicesSlice = createSlice({
  name: storeResources.INVOICES,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(ThunkGetInvoices.fulfilled, (state, action) => {
      state.invoices = action.payload;
    });
  },
});

export default invoicesSlice.reducer;
